<script lang="ts">
  import Column from '@athena-lib/Columns/Column.svelte';
  import Columns from '@athena-lib/Columns/Columns.svelte';
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import { StoryblokComponent } from '@storyblok/svelte';
  import AccordionItem from '@athena-lib/Accordion/AccordionItem.svelte';
  import { Accordion } from '@athena-lib/Accordion';
  import HeadingSmall from '@athena-lib/Text/HeadingSmall/HeadingSmall.svelte';
  import { KeyboardArrowRight } from '@athena-lib/Icons';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import ArrowBack from '@athena-lib/Icons/ArrowBack.svelte';
  import { Link } from '@athena-lib/Link';
  import { BaseHeading } from '@athena-lib/Text';
  import { RichText } from '../RichText';
  import { ensureLeadingSlash } from './shared/url-utils';
  import type { ExpandedSupportCategoryStoryBlok } from '$lib/server/expanders/supportCategoryExpander';

  function isNonEmptyArray<A>(arr: Array<A>): boolean {
    return arr.length > 0;
  }

  const { blok }: { blok: ExpandedSupportCategoryStoryBlok } = $props();
  const translations = getCommonTranslations();
</script>

<PageSection ySpace="medium">
  <Columns collapseBelow="lg" space="xlarge">
    <Column width={{ sm: 'auto', lg: '1/3' }}>
      <a href={blok.parentPath} class="flex items-center gap-4">
        <span aria-hidden="true">
          <ArrowBack sizeClass="h-6 w-6" />
        </span>
        <BaseHeading level={1} size="medium" class="text-center lg:text-left">
          {blok.name}
        </BaseHeading>
      </a>
      {#if isNonEmptyArray(blok.categories)}
        <nav
          aria-label={translations.supportCategories}
          class="mt-6 flex flex-col gap-2 px-medium lg:mt-14 lg:px-0"
        >
          {#each blok.categories as category}
            <a
              class="group relative flex items-center rounded-xl bg-st-gray-200 px-6 py-4 text-st-black hover:bg-st-yellow"
              href={ensureLeadingSlash(category.link)}
            >
              {category.label}
              <span aria-hidden="true" class="absolute right-6 hidden group-hover:block">
                <KeyboardArrowRight sizeClass="h-6 w-6" />
              </span>
            </a>
          {/each}
        </nav>
      {/if}
    </Column>
    <Column width={{ sm: 'auto', lg: '2/3' }}>
      {#each blok.body ?? [] as item (item._uid)}
        <StoryblokComponent blok={item} />
      {/each}
      {#if isNonEmptyArray(blok.faq)}
        <div class="px-medium lg:px-gutter lg:pb-medium">
          <HeadingSmall class="mb-8">{translations.faq}</HeadingSmall>
          <Accordion singleOpen>
            {#each blok.faq ?? [] as faqEntry}
              <AccordionItem heading={faqEntry.question ?? ''}>
                <RichText text={faqEntry.answer} />
                {#if faqEntry.link}
                  <Link
                    class="pt-4 text-sm font-bold underline underline-offset-2"
                    href={ensureLeadingSlash(faqEntry.link)}
                  >
                    {translations.readMoreText}
                  </Link>
                {/if}
              </AccordionItem>
            {/each}
          </Accordion>
        </div>
      {/if}
    </Column>
  </Columns>
</PageSection>
